import { DashboardSortKey, DashboardSortOrder } from 'store/fetchDashboardRuns';

export interface IRunsParams {
  page?: number;
  pageSize?: number;
  search?: string;
  state?: string;
  userId?: string;
  hasRunningTasks?: boolean;
  taskState?: string;
  updatedWithinDays?: string;
  sort?: DashboardSortKey;
  order?: DashboardSortOrder;
}

export default function buildRunsPath(projectId: string, params: IRunsParams = {}): string {
  const searchParams = new URLSearchParams();
  if (params.page) searchParams.set('page', String(params.page));
  if (params.pageSize) searchParams.set('page_size', String(params.pageSize));
  if (params.search) searchParams.set('search', params.search);
  if (params.state) searchParams.set('state', params.state);
  if (params.userId) searchParams.set('user_id', params.userId);
  if (params.hasRunningTasks) searchParams.set('has_running_tasks', 'true');
  if (params.taskState) searchParams.set('task_state', params.taskState);
  if (params.updatedWithinDays) searchParams.set('updated_within_days', params.updatedWithinDays);
  if (params.sort) searchParams.set('sort', params.sort);
  if (params.order) searchParams.set('order', params.order);
  const qs = searchParams.toString();
  return `projects/${projectId}/workflows${qs ? `?${qs}` : ''}`;
}
